import React from 'react';
import { motion } from 'framer-motion';
import {
  Box,
  Container,
  Flex,
  Heading,
  Text,
  SimpleGrid,
  VStack,
  List,
  ListItem } from
'@chakra-ui/react';
import { Quote, User } from 'lucide-react';
const MotionBox = motion(Box);
export function ProofSection() {
  const testimonials = [
  {
    quote:
    'I was stuck for 3 weeks appealing blindly. GMCRadar showed me issues Google never mentioned. Fixed them, appealed once — reinstated in 48 hours.',
    author: 'Fashion store owner'
  },
  {
    quote:
    "This saved my business. I didn't realise Google was checking signals outside my store. Once fixed, my account came back immediately.",
    author: 'Electronics brand'
  },
  {
    quote:
    "I wasted £2k on an 'expert' before this. This found more issues in 1 minute than they did in 2 weeks.",
    author: 'Home & Garden store'
  }];

  return (
    <Box as="section" py={24} position="relative">
      <Container maxW="container.xl" px={4}>
        {/* Testimonials */}
        <Box maxW="6xl" mx="auto" mb={32}>
          <SimpleGrid
            columns={{
              base: 1,
              md: 3
            }}
            spacing={8}>
            
            {testimonials.map((t, i) =>
            <MotionBox
              key={i}
              initial={{
                opacity: 0,
                y: 20
              }}
              whileInView={{
                opacity: 1,
                y: 0
              }}
              viewport={{
                once: true
              }}
              transition={{
                delay: i * 0.1
              }}
              bg="brand.card"
              border="1px solid"
              borderColor="brand.border"
              borderRadius="2xl"
              p={8}
              position="relative">
              
                <Box
                position="absolute"
                top={6}
                right={6}
                color="rgba(16, 185, 129, 0.2)">
                
                  <Quote size={48} />
                </Box>
                <Box position="relative" zIndex={10}>
                  <Text
                  fontSize="lg"
                  color="gray.300"
                  mb={8}
                  lineHeight="relaxed">
                  
                    "{t.quote}"
                  </Text>
                  <Flex
                  align="center"
                  gap={3}
                  borderTop="1px solid"
                  borderColor="brand.border"
                  pt={6}>
                  
                    <Flex
                    w={10}
                    h={10}
                    borderRadius="full"
                    bg="brand.dark"
                    align="center"
                    justify="center"
                    border="1px solid"
                    borderColor="brand.border">
                    
                      <User color="#6b7280" size={20} />
                    </Flex>
                    <Text fontWeight="medium" color="white">
                      — {t.author}
                    </Text>
                  </Flex>
                </Box>
              </MotionBox>
            )}
          </SimpleGrid>
        </Box>

        {/* Origin Story */}
        <Box maxW="3xl" mx="auto">
          <MotionBox
            initial={{
              opacity: 0,
              y: 20
            }}
            whileInView={{
              opacity: 1,
              y: 0
            }}
            viewport={{
              once: true
            }}
            bg="brand.dark"
            border="1px solid"
            borderColor="brand.border"
            borderRadius="2xl"
            p={{
              base: 8,
              md: 12
            }}>
            
            <Heading
              as="h2"
              fontSize={{
                base: '2xl',
                md: '3xl'
              }}
              fontWeight="bold"
              mb={6}>
              
              I built this after getting my own store suspended.
            </Heading>

            <VStack spacing={6} fontSize="lg" color="gray.300" align="stretch">
              <Text fontWeight="medium" color="red.400">
                No feedback. No clarity. No revenue.
              </Text>

              <Text>I spent months reverse-engineering:</Text>

              <Box
                pl={6}
                borderLeft="2px solid"
                borderColor="rgba(16, 185, 129, 0.3)">
                
                <VStack spacing={3} align="stretch">
                  {[
                  'What Google actually checks',
                  'Why appeals fail',
                  'What triggers reinstatement'].
                  map((item, i) =>
                  <Flex key={i} align="center" gap={2}>
                      <Box
                      w="6px"
                      h="6px"
                      borderRadius="full"
                      bg="brand.green" />
                    
                      <Text>{item}</Text>
                    </Flex>
                  )}
                </VStack>
              </Box>

              <Text
                fontSize="xl"
                fontWeight="medium"
                color="white"
                pt={4}
                borderTop="1px solid"
                borderColor="brand.border">
                
                This tool is everything I wish I had back then.
              </Text>
            </VStack>
          </MotionBox>
        </Box>
      </Container>
    </Box>);

}